import TestScreenshot from './TestScreenshot.jsx'

export default () => {
    return {
        path: '/test-screenshot',
        element: <TestScreenshot />,
    }
}
